// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubscriptionTerms_AcceptancesQueryInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * SubscriptionTerms_AcceptancesQueryInput — filters for
 * POST /subscriptions/admin-terms/acceptances.
 *
 * A POST because the SPA composable posts its filter object, matching the LGPD
 * audit endpoint next door. Every field is optional: no filter means the most
 * recent page.
 */
import { registerContract } from './validate'

export interface SubscriptionTerms_AcceptancesQueryInput {
term_id?: number
franquia_id?: number
data_inicio?: string
data_fim?: string
limit?: number
offset?: number
}

registerContract('SubscriptionTerms_AcceptancesQueryInput', {
  term_id:     { type: 'number',  required: false },
  franquia_id: { type: 'number',  required: false },
  data_inicio: { type: 'string',  required: false },
  data_fim:    { type: 'string',  required: false },
  limit:       { type: 'number',  required: false },
  offset:      { type: 'number',  required: false },
})
